import split from 'lodash/split';

import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useChangeIntervals = ({ calendar, onSuccess }) => {
  const { onSubmit: handleChangeIntervals } = useFetch(
    'calendar-playlist-change-intervals',
    Api.CALENDAR_PLAYLIST
  );

  const onChangeIntervals = ({ time, guid, day, playlistId }) => {
    const [stStart, stEnd] = split(time.begin.format('HH:mm'), ':');
    const [enStart, enEnd] = split(time.end.format('HH:mm'), ':');

    const st = parseInt(stStart) * 60 + parseInt(stEnd);
    const end = parseInt(enStart) * 60 + parseInt(enEnd);

    handleChangeIntervals({
      method: 'PUT',
      pathParams: {
        calendarId: calendar.id,
        guid,
      },
      body: {
        playlistId,
        intervals: {
          [day]: {
            st,
            end,
          },
        },
      },
      onSuccess,
    });
  };

  return {
    onChangeIntervals,
  };
};

export default useChangeIntervals;
